import { configureStore } from '@reduxjs/toolkit';

import { connectedSlice } from './slices/connected';
import { variablesSlice } from './slices/variables';

export const store = configureStore({
  reducer: {
    connected: connectedSlice.reducer,
    variables: variablesSlice.reducer,
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
